import {isNullOrUndefined} from "../../services/Validator";

export default function SystemDialogMainImage({imageUrl, alt}) {
    // Used through the app to display centered top image
    // in dialogs

    // BUILD
    if (isNullOrUndefined(imageUrl))
        return null
    return (
        <div className={"flex h-[64px] sm:h-[72px] items-center justify-center"}>
            <img className={"object-contain w-full h-full"}
                 src={imageUrl}
                 alt={alt} />
        </div>
    );
}